module.exports = __webpack_public_path__ + "static/media/ducanh-portrait.e4a13179.jpg";